import { render, staticRenderFns } from "./ActionOrigin.vue?vue&type=template&id=2a385a12"
import script from "./ActionOrigin.vue?vue&type=script&lang=js"
export * from "./ActionOrigin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports